import React, { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import API from '../api/axios';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';
import GoogleAuthButton from '../components/GoogleAuthButton';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/swipe" replace />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  setLoading(true);
  try {
    const response = await API.post('/api/auth/login', {
      email: formData.email.toLowerCase(),
      password: formData.password,
    });

    const { user, token, refresh_token } = response.data;
    login(user, token, refresh_token); // this now sets the header + checks profile

    // Navigate based on role
    if (user.role === 'admin') {
      navigate('/admin');
    } else {
      // Wait briefly for hasProfile to resolve inside login()
      try {
        await API.get('/api/profile/me');
        navigate('/swipe');
      } catch {
        navigate('/profile-setup');
      }
    }

  } catch (error) {
    setErrors({ general: error.response?.data?.message || 'Login failed. Please try again.' });
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Godly Match</h1>
          <p>Welcome back</p>
        </div>

        {errors.submit && (
          <div className="error-banner">{errors.submit}</div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              className={errors.email ? 'input-error' : ''}
              disabled={loading}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                className={errors.password ? 'input-error' : ''}
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {errors.password && <span className="error-text">{errors.password}</span>}
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/forgot-password" className="link">
            Forgot Password?
          </Link>
        </div>
        
        {/* Place this after your existing form submit button */}
<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  margin: '16px 0'
}}>
  <hr style={{ flex: 1, borderColor: '#ddd' }} />
  <span style={{ color: '#999', fontSize: '13px' }}>or</span>
  <hr style={{ flex: 1, borderColor: '#ddd' }} />
</div>

<GoogleAuthButton label="Continue with Google" />


        <div className="auth-footer">
          <p>Don't have an account? <Link to="/register" className="link-bold">Sign up</Link></p>
        </div>
        <footer style={{
  textAlign: 'center',
  padding: '20px 16px',
  fontSize: 13,
  color: '#999'
}}>
  <a href="/privacy" style={{ color: '#C8102E', textDecoration: 'none' }}>Privacy Policy</a>
  {' · '}
  <a href="/terms" style={{ color: '#C8102E', textDecoration: 'none' }}>Terms of Service</a>
  {' · '}
  <a href="/community-guidelines" style={{ color: '#C8102E', textDecoration: 'none' }}>Community Guidelines</a>
</footer>
      </div>
      
    </div>
  );
}